import { render, staticRenderFns } from "./plan-edit.vue?vue&type=template&id=60bd3d06&scoped=true&"
import script from "./plan-edit.vue?vue&type=script&lang=ts&"
export * from "./plan-edit.vue?vue&type=script&lang=ts&"
import style0 from "./plan-edit.vue?vue&type=style&index=0&id=60bd3d06&lang=scss&scoped=true&"
import style1 from "./plan-edit.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60bd3d06",
  null
  
)

export default component.exports